import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DataServiceService } from '../services/data-service.service';


interface Day {
  date: Date | null;
  notes: string;
}

@Component({
  selector: 'app-drivers-notes',
  templateUrl: './drivers-notes.component.html',
  styleUrl: './drivers-notes.component.scss'
})
export class DriversNotesComponent implements OnInit, OnChanges {
  @Input() driverId!: number | undefined;
  calendar: Day[][] = [];
  currentMonth = new Date();
  notes: { [key: string]: string } = {};
  activeTab: 'calendar' | 'list' = 'calendar';
  selectedNote: string | null = null;
  dispatches: any[] = [];

  weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  constructor(private dataService: DataServiceService) {
    this.buildCalendar();
  }

  ngOnInit() {
    const year = this.currentMonth.getFullYear();
    const month = this.currentMonth.getMonth();
    const startDate = new Date(year, month, 1);
    const endDate = new Date(year, month + 1, 0);

    const formattedStart = this.formatDate(startDate);
    const formattedEnd = this.formatDate(endDate);

    this.dataService.getDispatchOrdersForDateRange(this.driverId ?? 0, formattedStart, formattedEnd).subscribe(data => {
      this.dispatches = data;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['driverId'] && changes['driverId'].currentValue) {
      this.loadMonthData();
    }
  }

  loadMonthData() {
    if (!this.driverId) return;
    
    const year = this.currentMonth.getFullYear();
    const month = this.currentMonth.getMonth();
    const startDate = new Date(year, month, 1);
    const endDate = new Date(year, month + 1, 0);

    const formattedStart = this.formatDate(startDate);
    const formattedEnd = this.formatDate(endDate);

    this.dataService.getDispatchOrdersForDateRange(
      this.driverId,
      formattedStart,
      formattedEnd
    ).subscribe({
      next: (data: any) => {
        this.notes = {};
        data.forEach((dispatch: any) => {
          const date = dispatch.dailyDispatch.date.split('T')[0];
          const dailyNote = dispatch.dailyDispatch.notes;
          if (dailyNote) {
            this.notes[date] = dailyNote;
          }
        });
        this.buildCalendar();
      },
      error: (error) => console.error('Error loading dispatch data:', error)
    });
  }

  buildCalendar() {
    const year = this.currentMonth.getFullYear();
    const month = this.currentMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    
    this.calendar = [];
    let week: Day[] = [];

    // Add empty days until first day of month
    const firstDayOfWeek = firstDay.getDay();
    for (let i = 0; i < firstDayOfWeek; i++) {
      week.push({ date: null, notes: '' });
    }

    // Add all days of month
    for (let day = 1; day <= lastDay.getDate(); day++) {
      const date = new Date(year, month, day);
      week.push({
        date,
        notes: this.notes[this.formatDate(date)] || ''
      });

      if (week.length === 7) {
        this.calendar.push(week);
        week = [];
      }
    }

    // Add remaining empty days
    if (week.length > 0) {
      while (week.length < 7) {
        week.push({ date: null, notes: '' });
      }
      this.calendar.push(week);
    }
  }

  formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  previousMonth() {
    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() - 1);
    this.loadMonthData();
  }

  nextMonth() {
    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1);
    this.loadMonthData();
  }

  hasNoteForDate(date: Date | null): boolean {
    if (!date) return false;
    const dateStr = this.formatDate(date);
    return dateStr in this.notes;
  }

  handleDateClick(date: Date | null) {
    if (!date) return;
    const dateStr = this.formatDate(date);
    this.selectedNote = this.notes[dateStr] || null;
  }

  getNotesForMonth(): [string, string][] {
    console.log('notes', this.notes)
    return Object.entries(this.notes)
      .filter(([date]) => {
        const [year, month] = date.split('-').map(Number);
        return year === this.currentMonth.getFullYear() && 
               month === this.currentMonth.getMonth() + 1;
      })
      .sort(([a], [b]) => a.localeCompare(b));
  }

  isToday(date: Date | null): boolean {
    if (!date) return false;
    const today = new Date();
    return date.getDate() === today.getDate() && 
           date.getMonth() === today.getMonth() && 
           date.getFullYear() === today.getFullYear();
  }
}